<template>
  <div id="app">
    <GlobalLayout>
      <metainfo></metainfo>
      <component :is="navLayout">
        <router-view />
      </component>
    </GlobalLayout>
  </div>
</template>

<script>
import faviconUrl from '@/assets/images/favicon.ico';
import '@/utils/init-table-component';
import { useMeta } from 'vue-meta';
import WayfindingLayout from '@/components/wayfinding/WayfindingLayout.vue';
import GlobalLayout from '@/components/layouts/GlobalLayout.vue';
import { useAuthTokenExpiry } from '@/composables/auth-token-expiry';

const components = {
  'wayfinding-layout': WayfindingLayout,
  GlobalLayout,
};

const metaInfo = {
  title: 'Financing for the new economy | Clearco', // default title
  meta: [
    { name: 'robots', Name: 'robots', content: 'noindex,nofollow' },
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1.0' },
    // meta description - override on all indexable pages
    {
      vmid: 'description',
      name: 'description',
      content: 'Financing for the new economy',
    },
  ],
  link: [{ rel: 'shortcut icon', type: 'image/ico', href: faviconUrl }],
  script: [],
};

export default {
  components,
  setup() {
    useMeta(metaInfo);
    useAuthTokenExpiry();
  },
  computed: {
    navLayout() {
      return this.$route.meta.displayNav ? 'wayfinding-layout' : 'div';
    },
  },
};
</script>

<style lang="less">
@import 'assets/style/core.less';
@import 'assets/style/fonts/fonts.less';
@import 'assets/style/components/primevue-calendar.less';

#app {
  height: 100%;
}
</style>
